var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.842 7.48972C17.9485 8.10292 18.0016 8.72421 18.0007 9.34659C18.0007 12.1262 17.0072 14.4764 15.2782 16.0672H15.2805C13.7685 17.4638 11.6901 18.2723 9.2257 18.2723C6.80272 18.2723 4.47898 17.3098 2.76567 15.5965C1.05237 13.8832 0.0898438 11.5594 0.0898438 9.13646C0.0898438 6.71348 1.05237 4.38974 2.76567 2.67643C4.47898 0.963128 6.80272 0.000602837 9.2257 0.000602837C11.4936 -0.0259578 13.6838 0.826065 15.3376 2.37821L12.7293 4.9865C11.7865 4.08773 10.5281 3.59555 9.2257 3.61612C6.84238 3.61612 4.81765 5.22403 4.09592 7.38923C3.71325 8.52379 3.71325 9.75255 4.09592 10.8871H4.09934C4.8245 13.0489 6.84581 14.6568 9.22913 14.6568C10.4602 14.6568 11.5177 14.3416 12.3376 13.7843H12.3342C12.8103 13.4689 13.2175 13.0603 13.5314 12.5832C13.8452 12.106 14.0591 11.5703 14.1602 11.0082H9.2257V7.49086H17.842V7.48972Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.23c9080bbae3c96b6059eb70cd0c354f.svg";
export { ForwardRef as ReactComponent };